import * as FieldValidation from '../../shared/field-validation.js';
import { opCfg, formatPaymentDate } from './config.js';
import { opModal } from './dom.js';
import { getOpenPaymentDafCardType } from './daf-card-type.js';
import { showOpenPaymentAjaxMsg } from './ui-state.js';

export function openPaymentValidateCardForm() {
    const p = '#open_payment_';
    const valid = FieldValidation.validateCardPaymentFields(opModal(), {
        card: p + 'card',
        cvv: p + 'cvv2',
        expiryMonth: p + 'expiry_month',
        expiryYear: p + 'expiry_year',
        postalCode: p + 'avs_zip',
    }, {
        requireCreditFields: getOpenPaymentDafCardType() === 'credit',
    });
    if (valid !== true) {
        showOpenPaymentAjaxMsg('alert-danger', '<li>Please check the card fields.</li>');
        return false;
    }
    return true;
}

export function openPaymentInitDatepicker() {
    const $dp = opModal().find('#open_payment_datepicker');
    if (!$dp.length) {
        return;
    }
    const formatted = formatPaymentDate();
    if (!$dp.data('datepicker')) {
        $dp.datepicker({
            autoclose: true,
            todayHighlight: false,
            endDate: '0d',
            clearBtn: false,
            orientation: 'top',
            format: 'mm/dd/yyyy',
        });
    }
    opModal().find('#open_payment_date').val(formatted);
    $dp.datepicker('setDate', formatted);
}

export function openPaymentApplyKioskInputMasks() {
    if (opCfg().kioskValidated) {
        return;
    }
    FieldValidation.applyCardMasks(opModal(), {
        cvv: '#open_payment_cvv2',
        expiryMonth: '#open_payment_expiry_month',
        expiryYear: '#open_payment_expiry_year',
    });
}
